// Client-side counterpart of what the prerender script writes into <head>
// for non-home pages (the home page keeps syncDocument's i18n behaviour).
function setMeta(selector, value) {
  const el = document.querySelector(selector);
  if (el && value) el.setAttribute("content", value);
}

export function applyHead(route, url) {
  document.documentElement.lang = "es-MX";
  if (route.title) document.title = route.title;
  setMeta('meta[name="description"]', route.description);
  setMeta('meta[property="og:title"]', route.title);
  setMeta('meta[property="og:description"]', route.description);
  setMeta('meta[property="og:url"]', url);
  setMeta('meta[name="twitter:title"]', route.title);
  setMeta('meta[name="twitter:description"]', route.description);
  const canonical = document.querySelector('link[rel="canonical"]');
  if (canonical) canonical.setAttribute("href", url);
}
